module.exports = __webpack_public_path__ + "img/404.cdea5e1f.png";